import Ajax from "base/Ajax";
import {svg_include} from "index";
import Page from "webPage/Page";
import RangeInput from "util/RangeInput";
import debounce from "debounce";
import EventEmitter from "base/EventEmitter";
import handleEcologiData from "util/handleEcologiData";

export default class ProductFilters extends EventEmitter {

    constructor($element) {
        super();
        this.$element = $element;

        this.request = null;
        this.filters = {};
        this.isUniqueHeader = true;

        this.$filters = this.$element.find('.js-products-filters');
        this.$content = this.$element.find('.js-products-content');
        this.$header = this.$element.find('.js-products-heading');
        this.$secondaryContent = this.$element.find('.js-secondary-content');
        this.$productsContent = this.$content.find('.js-products-wrap');
        this.$pagination = this.$content.find('.js-pagination');
        this.$breadcrumb = $('.js-breadcrumb');

        this.ignoreUpdates = false;
        this.debouncedChange = debounce(this.emitChange.bind(this), 400);

        //Update this value when selecting from dropdown
        //Do an AJAX request to update the pages like other filters
        this.perPage = parseInt(this.$element.find('.js-products-per-page').val());

        //Update this based on the value of the sort by dropdown
        //Do an AJAX request to update the pages like other filters
        this.sort_by = this.$element.find('.js-products-sort-by').val();

        this.category = this.getCategory();
        this.productClickEvent = this.category === 'bespoke-awards' ? 'bespoke-product-click' : 'ots-product-click';
        this.filterChangeEvent = this.category === 'bespoke-awards' ? 'bespoke-product-filter' : 'ots-product-filter';

        this.buildRanges();

        this.bindEvents();
        this.updateLatestFilters();

    }

    bindEvents() {
        let me = this;

        this.on("change", ({filters, update, updateUrl}) => {
            if (this.ignoreUpdates) {
                return;
            }
            if ($(window).outerWidth() >= ProductFilters.SIDEBAR_SIZE) {
                this.updateLatestFilters();

                if (update === true) {
                    this.getProducts(updateUrl);
                }
            }

            if (updateUrl) {
                this.updateUrls();
            }

            this.updateMobileClear();
        });

        this.$element.on('click', 'a[href*="/product/"]', function () {
            let href = $(this).attr('href');
            try {
                dataLayer.push({
                    'event': me.productClickEvent,
                    'product-url': href,
                    'eventCallback': function () {
                        window.location.href = href;
                    }
                });
            } catch (e) {
                console.log(e);
                window.location.href = href;
            }
            return false;
        }).on('click', '.js-filter-value', function () {
            let $this = $(this);
            if ($this.is('.checkbox-link--disabled')) {
                return false;
            }

            $this.toggleClass('checkbox-link--checked');
            $this.attr("aria-checked", $this.is(".checkbox-link--checked") ? "true" : "false");

            let shouldUpdateUrls = $this.is('a')
            me.emitChange(true, shouldUpdateUrls);

            return false;
        }).on('click', '.js-change-page', function () {
            let $this = $(this);
            let pushState = $this.is('a');

            me.filters.page = parseInt($this.attr('data-page'));
            me.getProducts(pushState);

            $('html, body').animate({
                scrollTop: $('.js-breadcrumb').offset().top - 125,
            }, 600);

            return false;
        }).on('click', '.js-apply-filters', function () {
            me.updateLatestFilters();
            me.getProducts(true);
            $('body').removeClass('show-filter');
            return false;
        }).on('click', '.js-dropdown-arrow', function () {
            $(this).toggleClass('filter-section__arrow--open');
            $(this).closest('.js-filter-section').find('.filter-section__content').stop().slideToggle(300);
            return false;
        }).on('click', '.js-clear-all', function () {
            me.ignoreUpdates = true;
            me.clearFilters();
            me.ignoreUpdates = false;
            me.filters = {};
            me.emitChange();
            return false;
        }).on('click', '.js-close', function () {
            $('body').removeClass('show-filter');
            me.updateFilters();
            return false;
        }).on('click', '.js-show-filter-btn', function () {
            $('body').addClass('show-filter');
            return false;
        }).on('click', '.js-clear-section', function () {
            let attribute = $(this).attr('data-name');
            if ($(window).outerWidth() < ProductFilters.SIDEBAR_SIZE) {
                me.$filters.find('.js-filter-value[data-name="' + attribute + '"]').removeClass('checkbox-link--checked');
                me.updateMobileClear();
            }
            return false;
        }).on('change', '.js-products-per-page', function () {
            me.perPage = parseInt($(this).val());
            me.emitChange(false);
            me.getProducts(me.isUniqueHeader);
        }).on('change', '.js-products-sort-by', function () {
            me.sort_by = $(this).val();
            me.emitChange(false);
            me.getProducts(me.isUniqueHeader);
        });

        window.onpopstate = function (event) {
            let queryString = Page.get_query();

            let filters = {};

            let pageRegexp = new RegExp('^.*/page/([0-9]+)/?');
            let pagePattern = pageRegexp.exec(window.location.pathname);

            if (pagePattern !== null && 'undefined' !== typeof pagePattern[0]) {
                filters.page = pagePattern[1];
            }

            let url_parts = window.location.pathname.split('/');
            url_parts.forEach((value) => {
                if (value === '') {
                    return;
                }
                if (value === me.category) {
                    return;
                }

                let key = me.$filters.find('.js-filter-value[data-value="' + value + '"]').attr('data-name');

                if ('undefined' === typeof filters[key]) {
                    filters[key] = [];
                }

                filters[key].push(value);
            });


            me.filters = $.extend(true, {}, filters, queryString);

            me.updateFilters();
            me.getProducts(false);
        };
    }

    buildPagination(data, headers) {
        this.$pagination.html('');

        if ('undefined' === typeof headers['x-wp-totalpages']) {
            return;
        }
        let total_pages = parseInt(headers['x-wp-totalpages']);

        let total_results = 'undefined' === typeof headers['x-wp-total'] ? 0 : parseInt(headers['x-wp-total']);

        let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;

        let show_items = 5;
        let after_range = Math.floor((show_items - 1) / 2);
        let before_range = after_range;

        if (page <= before_range) {
            before_range = page - 1;
            after_range = show_items - before_range - 1;
        }

        if (total_pages - page <= after_range) {
            after_range = total_pages - page;
            before_range = show_items - after_range - 1;
        }

        let is_unique_page = data.isUniqueHeader;

        let base = this.generateUrl(this.filters);

        let $pagination = (eotwJSXFactory('section', {className: "pagination"}));

        let $wrap = (eotwJSXFactory('div', {className: "pagination__wrap js-wrap"}));
        if (page > 1) {
            if (is_unique_page) {
                $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page - 1), 'data-page': page - 1, className: "arrow-btn arrow-btn--pagination js-change-page", unsafeHtml: svg_include('arrow-btn')}),);
            } else {
                $wrap.append(eotwJSXFactory('button', {type: 'button', 'data-page': page - 1, className: "arrow-btn arrow-btn--pagination js-change-page", unsafeHtml: svg_include('arrow-btn')}),);
            }
        }

        let $list = (eotwJSXFactory('ol', {className: "pagination__list"}));

        for (let i = 1; i <= total_pages; i++) {
            if (1 !== total_pages && (!(i >= page + after_range + 1 || i <= page - before_range - 1) || total_pages <= show_items)) {
                $list.append(eotwJSXFactory('li', {className: "pagination__item"}, [
                    page === i ? (eotwJSXFactory('span', {className: "pagination__link js-pagination-link pagination__link--active"}, [i])) : (is_unique_page ? (eotwJSXFactory('a', {href: this.getPageLink(base, i), 'data-page': i, className: "pagination__link js-pagination-link js-change-page"}, [i])) : (eotwJSXFactory('button', {type: 'button', 'data-page': i, className: "pagination__link js-pagination-link js-change-page"}, [i])))
                ]),);
            }
        }

        $wrap.append($list);

        if (page < total_pages) {
            if (is_unique_page) {
                $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page + 1), 'data-page': page + 1, className: "arrow-btn arrow-btn--pagination arrow-btn--next js-change-page", unsafeHtml: (svg_include('arrow-btn'))}),);
            } else {
                $wrap.append(eotwJSXFactory('button', {type: 'button', 'data-page': page + 1, className: "arrow-btn arrow-btn--pagination arrow-btn--next js-change-page", unsafeHtml: (svg_include('arrow-btn'))}),);
            }
        }

        $pagination.append($wrap);

        let start = ((page - 1) * this.perPage) + 1;
        let end = Math.min(total_results, (start - 1 + this.perPage));

        $pagination.append(eotwJSXFactory('div', {class: "pagination__results"}, [
            eotwJSXFactory('p', null, ["Viewing ", start, "-", end, " of ", total_results, " results"])
        ]),);

        this.$pagination.html($pagination);
    }

    buildProduct(data) {

        let solution_type = data.attributes.filter((attr) => {
            return attr.id === 4;
        });

        let $solutionType = solution_type.length <= 0 ? '' : (eotwJSXFactory('div', {class: "card__attribute"}, [solution_type[0]['options'][0]]));

        let $image = 'undefined' !== typeof data.image_html ? data.image_html : '';

        return (eotwJSXFactory('div', {className: "columns__column"}, [
            eotwJSXFactory('div', {className: "card card--product"}, [
                eotwJSXFactory('div', {className: "card__image"}, [
                    $solutionType,
                    eotwJSXFactory('div', {unsafeHtml: $image})
                ]),
                eotwJSXFactory('div', {className: "card__content"}, [
                    eotwJSXFactory('h2', {className: "heading heading--product"}, [eotwJSXFactory('a', {className: "psuedo-link", href: data.permalink, unsafeHtml: data.name})]),
                    data.price_html !== '' ? (eotwJSXFactory('div', {className: "card__text"}, [
                        eotwJSXFactory('div', {className: "heading heading--product card__price", unsafeHtml: data.price_html}),
                        eotwJSXFactory('div', {className: "card__additional"}, ["based on a quantity of 10+"])
                    ])) : ''
                ])
            ])
        ]));
    }

    buildRanges() {
        this.ranges = RangeInput.apply(this.$filters);
        this.rangesMap = null;

        if (this.ranges.length <= 0) {
            return;
        }

        this.rangesMap = {};

        this.ranges.forEach((range) => {
            range.on("change", ({min, max}) => {
                if (!this.ignoreUpdates) {
                    this.debouncedChange();

                    this.updateUrls();
                }
            });

            this.rangesMap[range.getName()] = range;
        });
    }

    buildReadyMadeGlassBanner() {
        return (eotwJSXFactory('div', {className: "columns__column columns__column--full"}, [
            eotwJSXFactory('div', {className: "product-banner"}, [
                eotwJSXFactory('div', {className: "product-banner__image"}, [
                    eotwJSXFactory('img', {width: "160", height: "127", src: "/wp-content/uploads/2021/08/SY3021-160x127.jpg", className: "bg-image", alt: "", loading: "lazy", 'data-object-fit': "cover", srcSet: "/wp-content/uploads/2021/08/SY3021-320x254.jpg 2x", sizes: ""})]),
                eotwJSXFactory('div', {className: "product-banner__content"}, [
                    eotwJSXFactory('p', null, ["If you’re looking for an extended range of options, including tableware, gifts and lead crystal, please visit our other website:"]),
                    eotwJSXFactory('div', {className: "product-banner__actions"}, [
                        eotwJSXFactory('a', {href: "https://specefx.ordershop.co.uk", className: "btn btn--external btn--small", target: "_blank", rel: "noreferrer external noopener", 'data-wpel-link': "external"}, [
                            "Classic Crystal",
                            eotwJSXFactory('span', {className: "inline-icon", unsafeHtml: svg_include('external-white')})
                        ])
                    ])
                ])
            ])
        ]));
    }

    clearFilterSection(section) {
        this.$filters.find('.js-accordion[data-name="' + section + '"]').find('.js-filter.value').removeClass('checkbox-link--checked');
    }

    clearFilters() {
        this.$filters.find('.js-filter-value').removeClass('checkbox-link--checked');

        this.ranges.forEach((range) => {
            range.clear();
        });
    }

    emitChange(shouldUpdate = true, updateUrl = true) {
        if (this.ignoreUpdates) {
            return;
        }

        this.emit("change", {
            filters: this.getLatestFilters(), update: shouldUpdate, updateUrl: updateUrl,
        });
    }

    generateFilterLink(taxonomy, term, filters, ignorePage) {
        let attributes = $.extend(true, {}, filters);

        if ('undefined' === typeof attributes[taxonomy]) {
            attributes[taxonomy] = [];
        }

        if (attributes[taxonomy].indexOf(term) !== -1) {
            attributes[taxonomy].splice(attributes[taxonomy].indexOf(term), 1);
        } else {
            attributes[taxonomy].push(term);
        }

        return this.generateUrl(attributes, ignorePage);
    }

    generateUrl(filters, ignorePage) {
        let attributes = $.extend(true, {}, filters);
        let url = '/' + this.category + '/';
        let get_args = [];
        let url_parts = [];

        Object.keys(attributes).forEach((key) => {
            if (attributes[key].length === 0) {
                return;
            }
            if (['min_price', 'max_price'].indexOf(key) >= 0) {
                if (key === 'min_price' && attributes[key] === parseInt(this.$element.find('.js-range-input').attr('data-min'))) {
                    return;
                }
                if (key === 'max_price' && attributes[key] === parseInt(this.$element.find('.js-range-input').attr('data-max'))) {
                    return;
                }
                get_args.push(key + '=' + attributes[key]);
            } else if (attributes[key].length === 1) {
                url_parts.push(attributes[key][0]);
            } else if (['page'].indexOf(key) >= 0) {
                //noop
            } else {
                attributes[key].forEach((value) => {
                    get_args.push(key + '[]=' + value);
                });
            }
        });

        if (url_parts.length > 0) {
            url += url_parts.join('/') + '/';
        }

        if (this.filters.page > 1 && !ignorePage) {
            url += 'page/' + this.filters.page + '/';
        }

        if (get_args.length > 0) {
            url += '?' + get_args.join('&');
        }

        return url;
    }

    getCategory() {
        let parts = location.pathname.match(/[^\/]+/g);
        return parts[0] !== 'shop' ? parts[0] : null;
    }

    getLatestFilters() {
        let filters = [];

        this.$filters.find(".js-filter-value.checkbox-link--checked").each((_, el) => {
            let $el = $(el);
            let name = $el.attr("data-name");

            if ('undefined' === typeof filters[name]) {
                filters[name] = [];
            }

            filters[name].push($el.attr("data-value"));
        });

        if (this.$filters.find('.js-price-filter').length > 0) {
            let price_filters = {
                "min_price": parseInt(this.$filters.find('.js-range-min').val()), "max_price": parseInt(this.$filters.find('.js-range-max').val()),
            };
            filters = $.extend(price_filters, filters);
        }

        return filters;
    }

    getPageLink(base, i) {
        let link = base;

        if (i > 1) {
            link += 'page/' + i + '/';
        }

        link += this.pageQueryString(link);

        return link;
    }

    getProducts(pushState) {
        this.$content.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wc/v3', 'products', $.extend({
            sort_by: this.sort_by,
            per_page: this.perPage,
            status: 'publish',
            product_cat: this.category,
            is_ajax: true,
        }, this.filters));

        this.updateFilters();

        try {
            let eventData = {
                "event": this.filterChangeEvent,
                "filter-parameters": $.extend({
                    sort_by: this.sort_by, per_page: this.perPage, status: 'publish', product_cat: this.category,
                    is_ajax: true,
                }, this.filters)
            };
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }

        this.request.then((data) => {
            this.request = null;
            let headers;

            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }


            this.updateProducts(data, headers);
            this.$content.removeClass('loading');
        }).catch((e) => {
            this.request = null;
            this.$content.removeClass('loading');
        });

        if (pushState) {
            let url = this.generateUrl(this.filters);
            history.pushState({}, '', url);
        }
    }

    hideHeader() {
        this.$header.hide();
    }

    hideSecondaryContent() {
        this.$secondaryContent.hide();
    }

    pageQueryString() {
        let queryString = '';
        let filters = $.extend(true, {}, this.filters);

        delete filters.page;

        Object.keys(filters).forEach((key) => {
            if (filters[key].length === 1) {
                delete filters[key];
            }
        });

        if (Object.keys(filters).length > 0) {
            queryString += "?" + $.param(filters).replace(/%5B%5D/g, "[]");
        }

        return queryString;
    }

    showHeader() {
        this.$header.show();
    }

    showNoProductsMessage() {
        this.$productsContent.html(eotwJSXFactory('div', {className: "columns__column columns__column--full"}, [
            eotwJSXFactory('div', {className: "heading-section"}, [
                eotwJSXFactory('h2', {className: "heading heading--3"}, ["No Results"]),
                eotwJSXFactory('p', null, ["We can’t find any awards that perfectly match your search. Consider widening your search with some alternative filters."])
            ])
        ]),);
    }

    updateBreadcrumb(pages) {
        this.$breadcrumb.html('');
        let i = 0;
        let total = pages.length;
        pages.forEach((page) => {
            if (Array.isArray(page)) {
                if (i + 1 < total) {
                    this.$breadcrumb.append(eotwJSXFactory('a', {className: "breadcrumb__item", href: page[1]}, [page[0]]),);
                } else {
                    this.$breadcrumb.append(eotwJSXFactory('span', {className: "breadcrumb__item breadcrumb__item--active"}, [page[0]]),);
                }
                i++;
            }
        });
    }

    updateClearButton() {
        this.updateClearButtons(this.filters);
    }

    updateClearButtons(filters) {
        this.$filters.find('.filter-section').removeClass('filter-section--has-filters');

        if (Object.keys(filters).length > 0) {
            this.$filters.addClass('filters--has-filters');

            Object.keys(filters).forEach((key) => {
                this.$filters.find('.filter-section[data-name="' + key + '"]').addClass('filter-section--has-filters');
            });
        } else {
            this.$filters.removeClass('filters--has-filters');
        }
    }

    updateFilterInformation(information) {
        let me = this;
        let filters = this.getLatestFilters();

        Object.keys(information).forEach((type) => {

            Object.keys(information[type]).forEach((filter) => {

                let $filter = this.$filters.find('.js-filter-value[data-name="' + type + '"][data-value="' + filter + '"]');
                let amount = parseInt(information[type][filter]['number_posts']);
                let is_unique = information[type][filter]['is_unique'];

                $filter.find('.js-product-amount').text('(' + amount + ')');

                let tag = amount > 0 && is_unique ? 'a' : 'button';

                if (amount > 0) {
                    $filter.removeClass('checkbox-link--disabled');
                } else {
                    $filter.addClass('checkbox-link--disabled');
                }

                $filter.replaceWith(function () {
                    let attrs = {};

                    $.each($filter[0].attributes, function (idx, attr) {
                        attrs[attr.nodeName] = attr.nodeValue;
                    });

                    if (tag === 'button') {
                        delete attrs['href'];
                        attrs['type'] = 'button';
                    } else {
                        filters.page = 1;
                        attrs['href'] = me.generateFilterLink(type, filter, filters, true);
                    }

                    return $("<" + tag + " />", attrs).append($(this).contents());
                });
            });
        });
    }

    updateFilters() {
        this.ignoreUpdates = true;
        this.clearFilters();

        if (this.rangesMap !== null && this.rangesMap !== typeof "undefined") {
            this.rangesMap['price'].setValue({
                min: this.filters.min_price, max: this.filters.max_price,
            });
        }

        Object.keys(this.filters).forEach((key) => {
            if (['min_price', 'max_price'].indexOf(key) >= 0) {
                //noop
            } else if ('undefined' !== typeof key) {
                let value = this.filters[key];
                if (Array.isArray(value)) {
                    value.forEach((filter) => {
                        this.$filters.find('.js-filter-value[data-name="' + key + '"][data-value="' + filter + '"]').addClass('checkbox-link--checked');
                    });
                } else {
                    this.$filters.find('.js-filter-value[data-name="' + key + '"][data-value="' + value + '"]').addClass('checkbox-link--checked');
                }
            }
        });

        this.updateClearButton();
        this.ignoreUpdates = false;
    }

    updateHeader(data) {
        this.$header.html(eotwJSXFactory('div', {className: "product-header"}, [
            eotwJSXFactory('div', {className: "product-header__content"}, [
                eotwJSXFactory('h1', {className: "product-header__heading heading heading--2", unsafeHtml: data.header}),
                eotwJSXFactory('div', {className: "term-description", unsafeHtml: data.content})
            ]),
            eotwJSXFactory('div', {className: "product-header__image", unsafeHtml: data.image}),
            eotwJSXFactory('div', {className: "product-header__shape"})
        ]),);
    }

    updateLatestFilters() {
        this.filters = this.getLatestFilters();
        this.updateClearButton();
    }

    updateMetaInformation(data) {
        if ('undefined' !== typeof data['meta_title']) {
            $('title').text(data['meta_title']);
            $('meta[property="og:title"]').attr('content', data['meta_title']);
            $('meta[property="twitter:title"]').attr('content', data['meta_title']);
            $('meta[itemprop="name"]').attr('content', data['meta_title']);
            $('meta[itemprop="headline"]').attr('content', data['meta_title']);
        }

        if ('undefined' !== typeof data['meta_desc']) {
            $('meta[name="description"]').attr('content', data['meta_desc']);
            $('meta[property="og:description"]').attr('content', data['meta_desc']);
            $('meta[property="twitter:description"]').attr('content', data['meta_desc']);
            $('meta[itemprop="description"]').attr('content', data['meta_desc']);
        }

        if ('undefined' !== typeof data['canonical']) {
            $('link[rel="canonical"]').attr('href', data['canonical']);
            $('meta[property="og:url"]').attr('href', data['canonical']);
        }
    }

    updateMobileClear() {
        let filters = this.getLatestFilters();
        this.updateClearButtons(filters);
    }

    updateProducts(data, headers) {
        if (data.header) {
            this.updateHeader(data.header);
            this.updateMetaInformation(data.header);
            this.showHeader();
        } else {
            this.hideHeader();
        }

        if (data.pageContent) {
            this.updateSecondaryContent(data.pageContent);
        } else {
            this.hideSecondaryContent();
        }

        if ('undefined' !== typeof data.isUniqueHeader) {
            this.isUniqueHeader = data.isUniqueHeader;
        }

        if (data.breadcrumb) {
            this.updateBreadcrumb(data.breadcrumb);
        }

        $('html, body').animate({
            scrollTop: $('.js-breadcrumb').offset().top - 125,
        }, 600);

        if (data.items.length > 0) {
            this.$productsContent.html('');

            let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;

            let only_crystal = false;

            if ('undefined' !== typeof this.filters.material) {
                if (this.filters.material.length === 1) {
                    if (this.filters.material[0] === 'crystal-glass') {
                        only_crystal = true;
                    }
                }
            }

            if (only_crystal && page === 1) {
                this.$productsContent.append(this.buildReadyMadeGlassBanner());
            }

            data.items.forEach((product) => {
                this.$productsContent.append(this.buildProduct(product));
            });

            this.buildPagination(data, headers);

        } else {
            this.showNoProductsMessage();
            this.$pagination.html('');
        }

        if (data.filterInformation) {
            this.updateFilterInformation(data.filterInformation);
        }
    }

    updateSecondaryContent(data) {
        this.$secondaryContent.html(data);
        handleEcologiData();
    }

    updateUrls() {
        let me = this;
        let filters = this.getLatestFilters();

        this.$filters.find(".js-filter-value").each(function () {
            let $this = $(this);
            let href = $this.is('button') ? false : me.generateFilterLink($this.attr('data-name'), $this.attr('data-value'), filters, false);
            $this.attr('href', href);
        });
    }
}

ProductFilters.SIDEBAR_SIZE = 760;
ProductFilters.cached_requests = {};
